import { RequestParam, UserData } from '@com-delta-idp/mnx-skymiles-shared';
import { CustomErrorVariant } from '@com-delta-idp/mnx-utils';

export interface PartnersPersonalizationEngineRequest {
  userdata: Partial<UserData>;
  requestparam: RequestParam;
}

export interface PartnersPersonalizationEngineResponse {
  format: string;
  finalcontentPath: string;
  contentDetails: ContentDetails;
}

export interface MainContentDetails {
  'jcr:description'?: string[];
  minimumStay?: string;
  'cq:segments'?: string[];
  skyMilesTier?: string;
  analyticsPageName?: string;
  alertLevel?: string;
  teaserCampaign?: string[];
}

export interface ContentDetails extends MainContentDetails {
  parsys: Parsys;
}

export interface Parsys {
  partners: PEPartners;
}

export interface PEPartners {
  viewAllPartnersId: string;
  viewAllPartnersLabel: string;
  sectionTitle: string;
  partners: string[];
  viewAllPartnersCTA: string;
}

export interface AEMpartner {
  id: string;
  ctaURL: string;
  logo: string;
  logoAltText: string;
  ctaLabel: string;
  title: string;
  promoCode: string;
  ctaAriaLabel?: string;
}

export interface EngineType {
  single?: PartnersPersonalizationEngineResponse;
  // multiple?: MultiplePersonalizationEngineResponse;
  error?: CustomErrorVariant;
}
